import React, { Fragment, useState } from "react";
import profile from "../../images/profile.svg";
import Modal from "../Modal/Modal";
import public_block_link from "@images/public_block_link.svg";

function importAll(r) {
  let images = {};
  r.keys().forEach((item) => {
    const iconName = item.replace("./", "").split(".")[0];
    images[iconName] = r(item);
  });
  return images;
}

const iconImages = importAll(
  require.context("../../images/", false, /\.(png|jpe?g|svg)$/)
);

const PublicProfile = ({ data }) => {
  const { main_info, icons } = data;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const standart = main_info.user_mode === "standard";

  const truncateText = (text, maxLength) => {
    return text.length > maxLength
      ? `${text.substring(0, maxLength)}...`
      : text;
  };

  const handleIconClick = (shouldBlur, href) => (e) => {
    if (shouldBlur) {
      e.preventDefault();
      setIsModalOpen(true);
    } else {
    }
  };

  return main_info.full_name ? (
    <div className="public-profile-container">
      <div className="public-avatar-container">
        {main_info.avatar ? (
          <img
            src={main_info.avatar}
            alt={main_info.full_name}
            className="public-avatar-container__image"
          />
        ) : (
          <img
            src={profile}
            alt={main_info.full_name}
            className="public-avatar-container__absent"
          />
        )}
      </div>

      <div className="public-info-container profile_card">
        <h1 className="public-full-name">{main_info.full_name}</h1>
        {main_info.birthday && (
          <p className="public-birthday">{main_info.birthday}</p>
        )}
        {main_info.position && (
          <p className="public-position">{main_info.position}</p>
        )}
        {main_info.company && (
          <p className="public-company">{main_info.company}</p>
        )}
        {main_info.bio && (
          <p className={`public-bio ${standart && "public-blurred"}`}>
            {main_info.bio.split(/\r\n|\r|\n/).map((line, i) => (
              <Fragment key={i}>
                {line}
                <br />
              </Fragment>
            ))}
          </p>
        )}

        {main_info.main_button_name && (
          <a href={main_info.main_button_link} className="public-main-button">
            {main_info.main_button_name}
          </a>
        )}
      </div>

      <div className="public-icons-grid">
        {icons.map((icon, index) => {
          const shouldBlur = standart && index > 1;

          return (
            <a
              key={icon.position}
              href={shouldBlur ? "#" : icon.value}
              onClick={handleIconClick(shouldBlur, icon.value)}
              target={icon.target || "_self"}
              className="public-icon-item"
            >
              <div className="public-icon">
                <img
                  src={iconImages[icon.name]}
                  alt={icon.title}
                  className={`public-icon-image ${
                    shouldBlur ? "public-blurred" : ""
                  }`}
                  onError={(e) => {
                    e.target.src = iconImages["default"];
                  }}
                />
              </div>

              <span
                className={`public-icon-title ${
                  shouldBlur ? "public-blurred" : ""
                }`}
              >
                {truncateText(icon.title, 24)}
              </span>
            </a>
          );
        })}
      </div>

      {main_info.show_footer && (
        <a
          href={
            main_info.slug
              ? `https://yourcf.ru/?utm_source=yourcf&utm_medium=online&utm_campaign=${main_info.slug}`
              : "https://yourcf.ru/?utm_source=yourcf&utm_medium=online&utm_campaign=footer"
          }
          className="public-slug-button getcatr"
          target="_blank"
        >
          {I18n.t("copyright")}
        </a>
      )}

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className="show-modal-content">
          <img src={public_block_link} alt="public_block_link" />

          <div className="show-modal-content-title">
            {I18n.t("public_profiles.show.unable_link")}
          </div>

          <div className="show-modal-content-text">
            {I18n.t("public_profiles.show.unable_link_info")}
          </div>
        </div>
      </Modal>
    </div>
  ) : (
    <div className="public-no-data">
      {I18n.t("public_profiles.show.empty_profile")}
    </div>
  );
};

export default PublicProfile;
